import _ from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import {getList} from './service'

const model = createProjectModel({
    projectNamespace: 'autoTaskRecordCustomer',
    state: {
        tableList: {}, //  客户列表
    },

    effects: {
        *getTableList(__, {select, put, call}) {
            const {tableList} = yield select((allState) => allState[model.namespace])
            const newParams = {
                offset: tableList.pagination.pageSize * (tableList.pagination.current - 1),
                limit: tableList.pagination.pageSize,
                ...tableList.params,
            }
            const res = yield call(getList, {
                ...newParams,
            })
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    if (draft.tableList) {
                        draft.tableList.dataSource = res.data
                        draft.tableList.pagination.total = _.get(res, 'pagination.rows_found', 0)
                    }
                },
            })
        },
    },
})
export default model
